import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import WithPopover from '_app/shared/components/WithPopover';
import SharePopoverContent from './SharePopoverContent';
import {loadShareTexts} from '_app/shared/features/ShareTexts/shareTextsActions';
import {getMediaShareTexts} from '_app/shared/features/ShareTexts/shareTextsSelectors';
import {getMediaShareLinks} from '_app/shared/features/shareLinks/shareLinksSelectors';
import {addShareItem, fetchShareLink} from '_app/shared/features/shareLinks/shareLinksActions';
import {getProxiedAs} from '_app/shared/features/users/proxiedAs/proxiedAsSelectors';
import {userInfoShape} from '_app/shapes';
import './share-popover.less';

export class SharePopover extends Component {
	render() {
		const trigger = (
			<div className="fa fa-share-alt share-popover-trigger-icon">
				<span className="share-popover-trigger-text">Share</span>
			</div>
		);
		const titleId = 'share-popover-title';
		const {containerClassName, ...rest} = this.props;

		return (
			<WithPopover trigger={trigger}
				titleId={titleId}
				containerClassName={containerClassName}
				popoverProps={{
					autohide: true
				}}
			>
				<SharePopoverContent {...rest}
					titleId={titleId}
				/>
			</WithPopover>
		);
	}
}

SharePopover.propTypes = {
	media: PropTypes.object.isRequired,
	proxiedAs: userInfoShape,
	containerClassName: PropTypes.string,
	shareLinks: PropTypes.object,
	shareTexts: PropTypes.object,
	addShareItem: PropTypes.func.isRequired,
	loadShareTexts: PropTypes.func.isRequired,
	fetchShareLink: PropTypes.func.isRequired,
};

SharePopover.defaultProps = {
	shareLinks: {},
	shareTexts: {},
	containerClassName: ''
};

const mapStateToProps = function(state, ownProps) {
	const itemId = ownProps.media.ID;

	return {
		shareLinks: getMediaShareLinks(state, itemId),
		shareTexts: getMediaShareTexts(state, {
			match: {
				params: {
					mediaId: itemId
				}
			}
		}).data,
		proxiedAs: getProxiedAs(state)
	};
};

const mapDispatchToProps = {
	fetchShareLink,
	loadShareTexts,
	addShareItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(SharePopover);